import FileUploader from './components/FileUploader';
export default FileUploader;
import _uploadFile from './utils/upload-file';
export { _uploadFile as uploadFile };